import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { useEffect } from 'react';
import { getPrimaryTracker } from 'usage-tracker-container';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import MobileWrapper from '../components/mobile/containers/MobileWrapper';
import AddonsPickerList from '../components/plan-builder/AddonsPickerList';
import HubPlanPickerListContainer from '../components/plan-builder/HubPlanPickerList/HubPlanPickerListContainer';
import PlanBuilderContainer from '../components/plan-builder/PlanBuilderContainer';
import SummaryColumn from '../components/plan-builder/SummaryColumn';
import { NavItemEnum } from '../constants/routing/NavItems';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useQueryParamTerm, useQueryParamsEffect } from '../utils/urls/appQueryParamUtilsLegacy';
import PhoneSupportPlanBuilder from '../v2/components/phone-support/PhoneSupportPlanBuilder';
import { SCREENS } from '../v2/constants/tracking/Screens';
import { CREATE_A_BUNDLE } from '../v2/constants/tracking/TrackingSources';
import { trackPageViewWithLastKnownEventProperties } from '../v2/utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MobileBundlePage = () => {
  useDocumentTitle('bundle');
  useEffect(() => {
    getPrimaryTracker().setProperties({
      screen: SCREENS.BUNDLE,
      trackingSource: CREATE_A_BUNDLE
    });
    trackPageViewWithLastKnownEventProperties({});
    return () => {
      getPrimaryTracker().setProperties({
        trackingSource: undefined
      });
    };
  }, []);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  const productLines = ['MARKETING', 'SALES', 'SERVICE', 'CMS', 'OPERATIONS', 'COMMERCE'];
  return /*#__PURE__*/_jsxs(MobileWrapper, {
    navMarkerName: 'BUNDLE_PAGE',
    navItem: NavItemEnum.BUNDLE,
    children: [/*#__PURE__*/_jsxs(PPUIPageHeader, {
      children: [/*#__PURE__*/_jsx(ProductPageTitle, {
        nonProductIdentifier: NavItemEnum.BUNDLE
      }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
        nonProductIdentifier: NavItemEnum.BUNDLE
      })]
    }), /*#__PURE__*/_jsx(PlanBuilderContainer, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HubPlanPickerListContainer, {
          productLines: productLines
        }), /*#__PURE__*/_jsx(AddonsPickerList, {
          defaultOpen: true
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(SummaryColumn, {
            shareLinkAnchor: "",
            hubsSignupProductOverride: "bundle"
          }), /*#__PURE__*/_jsx(PhoneSupportPlanBuilder, {
            phoneSourceId: "bundle",
            screen: SCREENS.BUNDLE,
            apiName: "crm-suite-starter-bundle"
          })]
        })]
      })
    })]
  });
};
export default MobileBundlePage;